import { render, staticRenderFns } from "./BasicDataIndex.vue?vue&type=template&id=53a81c3d&scoped=true&"
import script from "./BasicDataIndex.vue?vue&type=script&lang=js&"
export * from "./BasicDataIndex.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataIndex.vue?vue&type=style&index=0&id=53a81c3d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a81c3d",
  null
  
)

export default component.exports